import { createContext } from 'react';
import { OtpModalVM } from './types';

export const initialContext: OtpModalVM['data'] = {
  open: false,
};

export const OtpModalContext = createContext<OtpModalVM>({
  data: initialContext,
  toggleModal: (open: boolean) => open,
});

export const ProviderOtpModal = OtpModalContext.Provider;
